import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavParams, LoadingController, NavController, Events, ModalController } from 'ionic-angular';
import { ResumeService } from '../../../../../../../UI/src/app/shared/resume/resume.service';
import { LibrarySelectPageComponent } from '../library-select/library-select.component';
import { TranslateService } from '@ngx-translate/core';
import { ToastControllerService } from '../../../../../providers/toast-controller.service';
import { Toast508Service } from '../../../../../providers/toast-508.service';
import { Storage } from '../../../../../../../UI/src/app/shared/constants';
import * as moment from 'moment/moment';

@Component({
  selector: 'page-edit-view',
  templateUrl: 'edit-view.component.html'
})
export class EditViewPageComponent implements OnInit, OnDestroy {
  public data: any;
  public config: any;
  public alive = true;
  public loading;
  public translations: any;
  private alertData: any;
  public editMode = true;
  public endDateDisable:Boolean = false;
  public dateFormat: any;
  public nonTimelines = ['OBJECTIVE', 'TRAVELPREFERENCES', 'EXPERIENCE LEVEL', 'ATTACHMENTS'];

  constructor(
    public navCtrl: NavController,
    public events: Events,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    private toastService: ToastControllerService,
    public resumeService: ResumeService,
    public navParams: NavParams,
    private translate: TranslateService,
    private toast508Service: Toast508Service
  ) {
    this.config = navParams.get("config");
    this.data = navParams.get("data");
    var culture = window.localStorage.getItem(Storage.CULTURE);
    this.dateFormat = moment.localeData(culture).longDateFormat('L');
    this.translate.get(['CAREER_EDIT_LABEL', 'CAREER_ADD_LABEL', 'CAREER_MISSING_LABEL'])
      .subscribe((obj) => {
        this.translations = obj;
      });
    this.setAttributes();
    this.loading = this.loadingCtrl.create({
      duration: 15000
    });
  }

  onChange(section, newVal) {
    section.newValue = newVal;
  }

  ngOnInit() {
    this.fillInDefaults();
    if (!this.data) {
      this.editMode = false;
      this.data = {
        attachments: []
      }
    }
  }

  showPopup() {
    this.alertData = {
      message: 'Please use Upload Video feature to record a new video.', type: 'success'
    };
    this.toastService.presentToast(this.alertData);
    this.toast508Service.toFocus();
  }

  ngOnDestroy() {
    this.alive = false;
  }

  getHeader() {
    return (this.editMode ? this.translations['CAREER_EDIT_LABEL'] : this.translations['CAREER_ADD_LABEL']) + ' ' + this.config.title;
  }

  toggleChanged(fieldName: string, event:any, section: any) {
    if(fieldName === 'IsCurrent') {
        this.endDateDisable = event.checked;
        let endDateField = this.config.modelFields.filter(function(model){
          return model.fieldName == 'EndDate';
        });
        if(endDateField.length > 0) {
          if(this.endDateDisable)
            endDateField[0].newValue = null;
          else
            endDateField[0].newValue = moment().format("YYYY-MM-DDThh:mm:ss");
        }
    }
  }

  saveAction(check) {
    var resumeObj = this.getSaveObject(check);
    if (check && resumeObj == null) {
      return;
    }
    this.loading.present();
    const tlData = this.resumeService.getTimelineMap();
    var saveObj = this.resumeService.getSaveResumeDTO();
    resumeObj = (this.nonTimelines.indexOf(this.config.name) >= 0) ? resumeObj : [resumeObj];
    if (this.config.name == 'ATTACHMENTS') {
      resumeObj = resumeObj.attachments;
    }
    saveObj[tlData[this.config.name].dto] = resumeObj;
    this.saveObjectAPI(saveObj);
  }

  showLibrary(section) {
    let library = this.modalCtrl.create(LibrarySelectPageComponent, { key: section.fieldName });
    library.onDidDismiss(data => {
      if (data) {
        section.newValue = data.value;
        this.data[data.key] = data.id;
      }
    })
    library.present();
  }

  updateAttachments(event) {
    this.data.attachments = event.attachments;
  }

  removeAction() {
    this.data["deleted"] = "True";
    this.saveAction(false);
  }

  getMaxStars() {
    return this.resumeService.getMaxStars(this.config);
  }

  fillInDefaults() {
    for (var i = 0; i < this.config.modelFields.length; i++) {
      const section = this.config.modelFields[i];
      if (section.displayTypeName == 'libraries') {
        section.options = this.getLibraryOptions(section.fieldName);
      }
      else if (section.displayTypeName == 'IsCurrent') {
        section.options = this.getLibraryOptions(section.fieldName);
      }
      else if (section.fieldName === 'WillingToTravelCode') {
        section.options.codes = section.options.codes.sort((a, b) => { return Number(a.itemCode) - Number(b.itemCode) });
      }
      section.newValue = this.getValue(section);
    }
  }

  getLibraryOptions(sectionNm) {
    const mappings = {
      'careerLevelCode': 'careerLevelOptions'
    }
    return this.resumeService.getSelectedResumeOption(mappings[sectionNm]).lookups;
  }

  private saveObjectAPI(saveObj) {
    this.resumeService.saveResumeData(saveObj)
      .takeWhile(() => this.alive)
      .subscribe(obj => {
        this.loading.dismiss();
        this.navCtrl.pop();
        this.events.publish('updateNewResumeData', true);
      }, err => {
        this.loading.dismiss();
        console.log("error in saveing obj", err);
      });
  }

  private getSaveObject(check) {
    var resumeObj = this.data ? this.data : {
      resumeId: this.resumeService.getResumeId()
    };
    for (var i = 0; i < this.config.modelFields.length; i++) {
      const section = this.config.modelFields[i];
      if (!check || this.isValid(section)) {
        if ((section.fieldDataTypeName == 'bit' && section.displayTypeName == 'checkbox')) {
          section.newValue = section.newValue == null ? false : section.newValue;
        }
        if (section.baseline || section.displayTypeName == 'starrating' || section.fieldName == 'LocationPreferences') {
          resumeObj[this.getKey(section.fieldName)] = section.newValue;
        } else {
          if (resumeObj.optional == null) {
            resumeObj.optional = {};
          }
          resumeObj.optional[this.getKey(section.fieldName)] = section.newValue;
        }
      } else {
        return null;
      }
    }
    return resumeObj;
  }

  private getKey(key) {
    //returns a first char lowerCased to match with API data.
    return key[0].toLowerCase() + key.slice(1)
  }

  private isValid(section) {
    const isrequired = section.attrlist['required'] == 'required';
    const valid = !isrequired || ((section.newValue ? true : false) && (section.newValue.trim() != ''));
    if (!valid) {
      this.alertData = {
        message: section.fieldTitle + ' ' + this.translations['CAREER_MISSING_LABEL'], type: 'warning'
      };
      this.toastService.presentToast(this.alertData);
      this.toast508Service.toFocus();
    }
    return valid;
  }

  private setAttributes() {
    for (var i = 0; i < this.config.modelFields.length; i++) {
      const section = this.config.modelFields[i];
      section.attrlist = {};
      for (var j = 0; j < section.attributes.length; j++) {
        section.attrlist[section.attributes[j].name] = section.attributes[j].value;
      }
    }
  }

  private getValue(field) {
    if (this.data) {
      const fieldNm = field.fieldName[0].toLowerCase() + field.fieldName.substring(1);
      if (field.baseline || field.displayTypeName == 'starrating' || fieldNm == 'locationPreferences') {
        return this.data[fieldNm];
      } 
      else if (this.data.length > 0) {
        return this.data.optional[fieldNm];
      }
      else {
        return null;
      }
    } else return null;
  }

}


// WEBPACK FOOTER //
// ./src/app/modules/edit-profile/resume/edit-view/edit-view.component.ts